import { feedBackInitialValue } from '@/types/feedBack';

export default {
  feedBack: feedBackInitialValue,
};
